import React, { Fragment } from 'react';
import Bullet from './Bullet';
import Header from './Header';
import styled from 'styled-components';

import { getContactNumber, getRoute, isBlogDomain } from '/lib/helpers';
import { replaceString } from '/imports/core/ui/helpers';
import { Text, ContentWrapper, SemiBold, LinkText } from '/imports/refundPolicy/ui/atoms';
import useDomain from '/imports/core/hooks/useDomain';
import useIntl from '/imports/core/api/useIntl';
import { useResponsive } from '/imports/core/api/responsiveContext';

const Refund = ({ getContactSupportLink }) => {
  const { t, locale } = useIntl();
  const { getBrandName } = useDomain();
  const { host } = useResponsive();

  return (
    <Fragment>
      <Header>{t('refund.title')}</Header>
      <ContentWrapper>
        <Text>
          <span
            dangerouslySetInnerHTML={{ __html: replaceString(t('refund.para1'), { Resumedone: getBrandName() }) }}
          />
        </Text>
        <Text>{t('refund.para2')}</Text>
        <Bullet>
          <LinkText
            dangerouslySetInnerHTML={{
              __html: replaceString(t('refund.policy_1'), {
                '/contact-us': getRoute('/contact-us', locale, false, host, isBlogDomain(host)),
              }),
            }}
          />
        </Bullet>
        <Bullet>
          <LinkText
            dangerouslySetInnerHTML={{
              __html: getContactSupportLink(),
            }}
          />
        </Bullet>
        <Bullet>
          <LinkText dangerouslySetInnerHTML={{ __html: getContactNumber(host, t('refund.para2_sub3'), t) }} />
        </Bullet>
        <Text>{t('refund.para3')}:</Text>
        <Text isList>
          1) <span dangerouslySetInnerHTML={{ __html: t('refund.para3_sub1') }} />
        </Text>
        <Text isList>2) {t('refund.para3_sub2')}</Text>
        <Text>
          <SemiBold>{t('refund.please_note_title')}: </SemiBold>
          <DangerText>{t('refund.please_note')}</DangerText>
        </Text>
        <Text>{t('refund.please_note_info')}</Text>
      </ContentWrapper>
    </Fragment>
  );
};

export default Refund;

const DangerText = styled.div`
  color: #e02020;
  display: inline;
`;
